import { BASE_URL } from "../config";

// upload image to cloudinary
export const UPLOAD_IMAGE = 'https://api.cloudinary.com/v1_1/nfsea-tools/image/upload';

// auth
export const LOGIN = `${BASE_URL}/authentication`;

export const REGISTER = `${BASE_URL}/users/create`;

export const UPDATE_USER = `${BASE_URL}/users/updateuser`;

// collections
export const CREATE_COLLECTION = `${BASE_URL}/collection/create`;

export const ALL_USER_COLLECTIONS = `${BASE_URL}/collection/getusercollections`;

// nfts
export const CREATE_NFT = `${BASE_URL}/nft/createnft`;

// subscription
export const CHECKOUT = `${BASE_URL}/nft/checkout`;